<div class="page-container">
  @if(pageStatus === 'loading') {
    <app-loading [text]="'Um momento...'"></app-loading>
  } @else if(pageStatus === 'error') {
    <div class="page-content h-100">
      <app-status-message
        class="d-column h-100"
        title="Ops. Algo deu errado!"
        body="Tente novamente mais tarde."
        illustration="sad"
        [footerButtonProps]="errorButtonProps"
      ></app-status-message>
    </div>
  } @else if (pageStatus === 'success') {
    <div class="page-content h-100">
      <app-status-message
        class="d-column h-100"
        title="Conta fechada!"
        body="Em breve, o garçom irá até sua mesa para receber o pagamento."
        illustration="happyCheck"
        [footerButtonProps]="closeTableButtonProps"
      ></app-status-message>
    </div>
  } @else if (pageStatus === 'default') {
    <app-bar
      [title]="pageTitle"
      (backButtonClick)="handleBackButtonClick()"
    ></app-bar>

    <div class="page-content">
      <section class="page-section border-bottom gap-2">
        <h2 class="title-large">
          Resumo dos pedidos
        </h2>

        <ul class="table-details-list">
          @for(section of ownerSections; track section.userId){
          @if(section.name){
          <li class="table-details-owner">{{ section.name }}</li>
          }
          <li class="table-details-item" *ngFor="let item of section.items">
            <span class="table-details-item-info">
              <span class="table-details-item-quantity">{{ item.type === 'WEIGHTABLE' ? 1 : item.qtyGrouped || item.qty }}</span>
              <span class="table-details-item-name">{{ item.name }}</span>
              <span class="table-details-item-name" *ngIf="item.type === 'WEIGHTABLE'">({{ item.qty }}kg)</span>
              <span class="table-details-item-value ml-auto">{{ item.valueGrouped || item.value | currency }}</span>
            </span>

            @if(hasComplementos(item) && !isExpanded(item.id)) {
              <span class="table-details-item-options">
                @if(getFirstComplemento(item)) {
                  <ul class="table-details-item-options-list">
                    @if(getFirstComplemento(item).type === 'option') {
                      <li class="table-details-item-option">
                        <span>
                          {{ getFirstComplemento(item).data.qty }}x {{ getFirstComplemento(item).data.name }}
                        </span>
                      </li>
                    }
                    @if(getFirstComplemento(item).type === 'additionalInfo') {
                      <li class="table-details-item-option">
                        <span>
                          Obs: {{ getFirstComplemento(item).data }}
                        </span>
                      </li>
                    }
                  </ul>
                }
              </span>
              @if(hasMoreThanOneComplemento(item)) {
                <button
                  class="table-details-item-toggle"
                  (click)="toggleExpand(item.id)"
                  type="button"
                >
                  <span class="table-details-item-toggle-text">
                    Ver mais
                  </span>
                  <mnt-icon
                    icon="caret-down"
                    size="16"
                    color="#0A639A"
                  ></mnt-icon>
                </button>
              }
            }

            @if(isExpanded(item.id)) {
              <span class="table-details-item-options">
                @if(item.options && item.options.length > 0) {
                  <ul class="table-details-item-options-list">
                    <li class="table-details-item-option" *ngFor="let option of item.options">
                      <span>
                        {{ option.qty }}x {{ option.name }}
                      </span>
                    </li>
                  </ul>
                }
              </span>
              <span class="table-details-item-options" *ngIf="item.additionalInfo">
                <ul class="table-details-item-options-list">
                  <li class="table-details-item-option">
                    <span>
                      Obs: {{ item.additionalInfo }}
                    </span>
                  </li>
                </ul>
              </span>
              <button
                class="table-details-item-toggle table-details-item-toggle-less"
                (click)="toggleExpand(item.id)"
                type="button"
              >
                <span class="table-details-item-toggle-text">
                  Ver menos
                </span>
                <mnt-icon
                  icon="caret-up"
                  size="16"
                  color="#0B2C46"
                ></mnt-icon>
              </button>
            }
          </li>
          }
        </ul>
      </section>

      <section class="page-section gap-2">
        <app-table-values-summary-list
          [hasCashback]="(table?.cashbackApplied ?? 0) > 0"
          [cashbackValue]="table?.cashbackApplied ?? 0"
        ></app-table-values-summary-list>
      </section>
    </div>
    <div class="page-footer d-column gap-3 mt-auto">
      <mnt-button
        class="w-100"
        variant="emphasis"
        color="primary"
        size="large"
        [label]="buttonLabel"
        [disabled]="!isOpened"
        (buttonClick)="handleCloseTable()"
        full-width
      ></mnt-button>
    </div>
  }
</div>
